import ChatLayout from '@src/components/Organism/Chat/ChatLayout';
import React from 'react';

/**
 * /chat — 데스크톱: 목록+빈화면 2분할 / 모바일: 목록만.
 */
const ChatListPage = () => <ChatLayout />;

export default ChatListPage;
